<template>
    <div class="ui-overlay">
        <svg class="ui-overlay__svg" :viewbox="`0 0 ${width} ${height}`" :width="width" :height="height">
            <defs>
                <mask id="mask" x="0" y="0" :width="width" :height="height">
                    <rect x="0" y="0" :width="width" :height="height" fill="#fff" />
                    <template v-for="rect in renderRects">
                        <rect
                            :key="rect.key"
                            :x="rect.left"
                            :y="rect.top"
                            :width="rect.width"
                            :height="rect.height"
                            :rx="rect.rx || 0"
                            :ry="rect.ry || 0">
                        </rect>
                    </template>
                </mask>
            </defs>

            <rect x="0" y="0" :width="width" :height="height" mask="url(#mask)" :fill="color" :fill-opacity="opacity" />
        </svg>
    </div>
</template>

<script>
    import { TweenLite } from 'gsap'

    export default {
        name: 'ui-overlay',
        props: {
            opacity: {
                type: Number,
                default: 0.7
            },
            color: {
                type: String,
                default: '#121258'
            },
            rects: {
                type: Array,
                default: () => []
            }
        },
        data () {
            return {
                renderRects: [],
                width: '100%',
                height: '100%'
            }
        },
        methods: {
            getHiddenDataRect (rect) {
                return {
                    key: rect.key,
                    width: 0,
                    height: 0,
                    top: rect.top + (rect.height/2),
                    left: rect.left + (rect.width/2),
                    rx: 100,
                    ry: 100
                }
            },
            updateRects (newRects) {
                const usedKeys = []
                const removeKeys = []

                newRects.forEach(rect => {
                    const usedRectIndex = this.renderRects.findIndex(r => r.key === rect.key)
                    usedKeys.push(rect.key)

                    if (usedRectIndex > -1) {
                        TweenLite.to(this.renderRects[usedRectIndex], 0.6, rect)
                    } else {
                        this.renderRects.push(this.getHiddenDataRect(rect))
                        const index = this.renderRects.length - 1
                        setTimeout(() => {
                            TweenLite.to(this.renderRects[index], 0.6, rect)
                        }, 100)
                    }
                })

                this.renderRects.forEach(rect => {
                    if (usedKeys.indexOf(rect.key) < 0) removeKeys.push(rect.key)
                })

                removeKeys.forEach(key => {
                    const index = this.renderRects.findIndex(rect => rect.key === key)
                    const rect = this.renderRects[index]

                    TweenLite.to(this.renderRects[index], 0.3, this.getHiddenDataRect(rect))

                    setTimeout(() => {
                        this.renderRects.splice(index, 1)
                    }, 300)
                })
            },
            resize () {
                this.width = this.$el.clientWidth
                this.height = this.$el.clientHeight
            }
        },
        watch: {
            rects (newRects) {
                this.updateRects(newRects)
            }
        },
        mounted () {
            window.addEventListener('resize', this.resize)
            this.resize()
            if (this.rects && this.rects.length) {
                this.updateRects(this.rects)
            }
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.resize)
        }
    }
</script>

<style lang="stylus">
    .ui-overlay {
        position fixed
        top 0
        right 0
        bottom 0
        left 0
        z-index 1000
        overflow hidden
        transition opacity .35s ease-in
        &__svg {
            display block
            width 100%
            height 100%
        }
    }
</style>
